var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nutri-score-container"},_vm._l((_vm.scores),function(item){return _c('div',{key:item.letter,staticClass:"nutri-score",class:[`score-${item.letter.toLowerCase()}`, { selected: _vm.selected === item.letter }]},[_vm._v(" "+_vm._s(item.letter)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }